import React from 'react';
import { EmptyMeasurementsList } from '../UI/EmptyMeasurementsList/EmptyMeasurementsList';
import cls from './MeasurementsListWrapper.module.css';
import { MeasurementsList } from '../MeasurementsList/MeasurementsList';
import { useSelector } from 'react-redux';
import { measurementsSelector } from '../../../store/slices/measurementsSlice/measurementsSlice';

export const MeasurementsListWrapper = () => {
    const measurementsIds = useSelector(measurementsSelector.selectIds);
    const isEmpty = !measurementsIds.length;
    return <>{isEmpty ? <EmptyMeasurementsList /> : <MeasurementsList />}</>;
};
